// @ts-nocheck
export const sectionOfficesAdapter = (data: any) => {
  const { notification } = data

  return {
    notificationText: notification,
  }
}
